module.exports = __webpack_public_path__ + "static/img/barra_1.d966e41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_1.png
// module id = g+VX
// module chunks = 0